<template>
  <div class="d-flex align-items-center no-selector p-2 cursor-pointer title-bar">
    <!-- Modal -->
    <Modal
      v-if="selected != null"
      :open="true"
      :title="preferenceName"
      @close="closeModal()"
    >
      <PreferenceConfigEditView
        :current-name="preferenceName"
        :preference-names="preferenceNames"
        :base-selector="baseSelector"
        @Update="update"
        @Copy="copy"
      />
    </Modal>
    <!-- Header -->
    <RuleSmallButton
      :disabled="isLoading"
      class="btn-danger p-2 small-button-width fw-bold"
      :title="'-'"
      @click.native="remove()"
    />
    <div
      class="d-flex align-self-center"
      :disabled="isLoading"
      @click="togleDisplay()"
    >
      <SelectorCaret
        class="mx-1"
        :class="isLoading ? 'cursor-disabled' : ''"
        :display="display"
      />
    </div>
    <h3 class="d-flex align-self-center mb-0 mx-1">
      <div
        class="text-center me-1"
        :class="isLoading ? 'cursor-disabled' : ''"
        :disabled="isLoading"
        @click="togleDisplay()"
      >
        {{ trans('subscription.classification_config.classification_config') }}
      </div>
      <button
        :disabled="isLoading"
        type="button"
        class="btn btn-secondary button-text mt-1 mb-2 p-1"
        @click="select()"
      >
        <span class="fa fa-cogs" />
        <b class="mx-1">{{ preferenceName }}</b>
      </button>
    </h3>
    <div
      class="flex-grow-1"
      :class="isLoading ? 'cursor-disabled' : ''"
      :disabled="isLoading"
      @click="togleDisplay()"
    >
      <!-- The flex grow will otherwise not work in aattendance -->
      &nbsp;
    </div>
  </div>
</template>

<script>
import Modal from '@/employees/AttendanceList/components/Modal'
import PreferenceConfigEditView from '@/employees/components/PreferenceConfig/PreferenceConfigEditView'
import SelectorCaret from '@/employees/components/PreferenceConfig/Selector/SelectorCaret'
export default {
  name: 'PreferenceConfigHeader',
  components: {
    Modal,
    PreferenceConfigEditView,
    SelectorCaret,
  },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
    isLoading: {
      required: true,
      type: Boolean,
    },
    preferenceName: {
      required: true,
      type: String,
    },
    preferenceNames: {
      required: true,
      type: Array,
    },
    baseSelector: {
      required: false,
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      selected: null,
    }
  },
  computed: {
    display: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  methods: {
    remove () {
      this.$emit('Remove', this.preferenceName)
    },
    togleDisplay () {
      this.display = !this.display
    },
    copy () {
      this.$emit('Copy', this.preferenceName)
    },
    update ({ name, baseSelector }) {
      this.$emit('Update', { newPreferenceName: name, oldPreferenceName: this.preferenceName, baseSelector: baseSelector })
      this.selected = null
    },
    select () {
      this.selected = true
    },
    closeModal () {
      this.selected = null
    },
  },
}
</script>

<style scoped>
h3 {
  line-height: unset;
  margin-top: 0px;
  white-space: nowrap
}
.no-selector {
  background-color: #d3d3d3ad;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-disabled {
  cursor: not-allowed;
}
.preference-name {
  font-size: 1.3rem;
}
.title-bar {
  border-bottom: solid;
  border-bottom-width: 1px;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  border-top: solid;
  border-top-width: 1px;
  border-top-color: rgba(0, 0, 0, 0.2);
}
.button-text {
  text-align: center;
  text-transform: none;
}
</style>
